import { useState } from "react";
import ReactSimplyCarousel from "react-simply-carousel";
import { ReactComponent as LeftArrow } from "assets/img/icons/leftArrow.svg";
import { ReactComponent as RightArrow } from "assets/img/icons/rightArrow.svg";

function CustomCarousel({ children, ...rest }) {
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);

  return (
    <ReactSimplyCarousel
      {...rest}
      containerProps={{
        className: "carouselContainer",
      }}
      activeSlideIndex={activeSlideIndex}
      onRequestChange={setActiveSlideIndex}
      forwardBtnProps={{
        children: <RightArrow className="rightIcon" />,
        className: "forwardButton",
      }}
      backwardBtnProps={{
        children: <LeftArrow className="leftIcon" />,
        className: "backwardButton",
      }}
      dotsNav={{
        show: true,
        containerProps: {
          className: "dotnavs",
        },
        itemBtnProps: {
          className: "simpleDotNav",
        },
        activeItemBtnProps: {
          className: "activeDotNav",
        },
      }}
    >
      {children}
    </ReactSimplyCarousel>
  );
}

export default CustomCarousel;
